
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">


  <div class="Column-new colmd3">

    <div class="card card padding-left-5px padding-right-5px height-100pe">

      <div class="card-header wh-header header3 padding-right-32px bk-color-sky padding-bottom-3px">
        <div class="row margin-top10px nav-link-hand">


          <label class="wh-header labcolor border-radius-4px padding-top-5px padding-bottom-4px margin-bottom-0px bk-color-sky font-size-14 font-weight-bold color-Assign">
            Healins Life Reports
          </label>



        </div>
        <div class="row margin-top10px ">

          <label class="wh-header font-weight-normal labcolor border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-sky"
                 hidden>
            Doctors
          </label>


        </div>

      </div>
      <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-sky">
        <div class="row border-bottom-2px  background-consumption margin-left-0px margin-right-0px">

          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="row ">
              <div class="col-md-11">
                <label class="margin-bottom-0px font-weight-normal font-size-14">Modules</label>
              </div>

            </div>

            <div class="row margin-left-0px  margin-bottom-5px">

              <div class="col-md-12 padding-left-0px my-profile-form">

                <!--Report Modules List FacilityList-->
                <CustomDataByRequestType RequestedType="Report Modules List"
                                         (keyChange)="ReportChanged($event)"
                                         required>
                </CustomDataByRequestType>
              </div>
            </div>
          </div>

        </div>
        <!--<div class="row padding-top-5px padding-bottom-10px margin-right-0px margin-left-5px">
          <div class="col-md-12 padding-left-0px">
            <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
          </div>
        </div>-->
        <div>
          <div class="chatsd product-chart-wrapper product-chat-height-557 agreement-chart-wrapper scroll padding-lrt ">
            <div *ngIf="isRequesting">

              <div class="loader-text">
                <div class="loader-text2">

                  <div class="lds-facebook">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <div class="margin-top-20px margin-left-5px">
                    <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                  </div>
                  <!--Loading Please Wait...-->
                </div>
              </div>


            </div>
            <div *ngIf="ReportsList">
              <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" *ngFor="let r of ReportsList" (click)="SelectedReport(r)">
                   
                <div class="col-md-12 margin-top-5px margin-bottom-5px">

                    <div class="row">
                      <div class="col-md-12 padding-left-0px">
                        <div class="row margin-left-0px">

                          <label class="margin-bottom-0px ">
                          {{r.ReportName}}
                          </label>

                        </div>

                      </div>
                    </div>
                  

                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>




  <div class="nk-column2">

    <div class="card height-100pe">

      <div class="card-header background-white pad5">
        <div class="row" *ngIf="SelectedReportItem">
          <div class="col-md-8">            
            <label class="margin-bottom-0px f2 float-left">{{mreq.QueryData}} =>  {{SelectedReportItem.ReportName}}</label>            
          </div>
          <!--<div class="col-md-4 float-right">
            <button type="submit"
                    (click)="OnNavigate()"
                    class="float-right btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px">
              Excel <i class="far fa-file-excel link6 adm-color-green"></i></button>
            <button type="submit" class="float-right btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px">Generate</button>
          </div>-->
        </div>


      </div>

      <div class="card-body background-white padding-top-5px">
        <div class=" padding-lrt ">

          <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px">

            <div class="row">
              <div class="col-md-2" *ngIf="SelectedReportItem && SelectedReportItem.IsFacility">
                <div class="row">
                  <label class="margin-bottom-0px font-family13px">Facility</label>
                </div>
                <div class="row">
                  <div class="col-md-12 padding-left-0px my-profile-form">
                    <CustomDataByRequestType RequestedType="FacilityList" ActorCode={{ActorCode}}
                                             (keyChange)="Roleassign($event)"
                                             [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode" SelectedValue="SelectedFacilityCode"
                                             required>
                    </CustomDataByRequestType>
                  </div>
                </div>
              </div>
              <div class="col-md-2" *ngIf="SelectedReportItem && SelectedReportItem.IsFromDate">
                <div class="row">
                  <label class="margin-bottom-0px font-family13px">From Date</label>
                </div>
                <div class="row">
                  <div class="col-md-12 padding-left-0px my-profile-form">
                    <div class="date-form">
                      <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                             (ngModelChange)="dataChanged($event)">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                    <!--<div class="date-form">
            <input type="text" class="form-control form-control-patient" placeholder="From Date"
                   name="df" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" #dfm="ngbDatepicker">
            <a (click)="dfm.toggle()" class="nav-link-hand">
              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

            </a>
          </div>-->
                  </div>
                </div>
              </div>
              <div class="col-md-2" *ngIf="SelectedReportItem && SelectedReportItem.IsToDate">
                <div class="row">
                  <label class="margin-bottom-0px font-family13px">To Date</label>
                </div>
                <div class="row">
                  <div class="col-md-12 padding-left-0px my-profile-form">
                    <div class="date-form">
                      <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedToDate" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker"
                             (ngModelChange)="dataChanged($event)">

                      <a (click)="d1.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                    <!--<div class="date-form">
            <input type="text" class="form-control form-control-patient" placeholder="To Date"
                   name="dp" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" #din="ngbDatepicker">
            <a (click)="din.toggle()" class="nav-link-hand">
              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

            </a>
          </div>-->
                  </div>
                </div>
              </div>
              <div class="col-md-2" *ngIf="SelectedReportItem && SelectedReportItem.IsEmployee">
                <div class="row">
                  <label class="margin-bottom-0px font-family13px">Employee</label>
                </div>
                <div class="row">
                  <div class="col-md-12 padding-left-0px my-profile-form">
                    <CustomDataByRequestType RequestedType="FacilityList" ActorCode={{ActorCode}}
                                             (keyChange)="Roleassign($event)"
                                             [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode" SelectedValue="SelectedFacilityCode"
                                             required>
                    </CustomDataByRequestType>
                  </div>
                </div>
              </div>
              <div class="col-md-2" *ngIf="SelectedReportItem">
                <div class="row">
                  <button type="submit"
                          (click)="OnNavigate()"
                          class="float-right btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px">
                    Excel <i class="far fa-file-excel link6 adm-color-green"></i>
                  </button>
                  <button type="submit" (click)="OnGenerate()"
                          class="float-right btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px">
                    Generate
                  </button>
                </div>
              </div>
            </div>

            <!--<div class="row bk-color-sky" *ngIf="ReportsData" hidden>
              {{ReportsData}}
            </div>-->

            <div *ngIf="ReportDataModel" class="margin-top-10">
              <div class="card margin-bottom-5px" *ngFor="let obj of ReportDataModel">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px">
                  <div class="row">
                    <div class="col-md-4">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button">
                          {{obj.Name}}
                        </button>
                      </h5>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="table-component">
                          <div class="table-responsive">
                            <table class="table table-striped"
                                   cols="auto,2*,*,*,*,*,*,*">
                              <thead class="">
                                <tr>
                                  <th *ngFor="let col of obj.TableColumns |  keyvalue" class="padding-top-4px padding-bottom-4px">
                                    {{col.value}}
                                  </th>
                                </tr>
                              </thead>
                              <tbody class="table-body">
                                <tr *ngFor="let row of obj.TableRows">
                                  <td class="td-padding-tb" *ngFor="let col of obj.TableColumns |  keyvalue">
                                    {{row[col.value]}}
                                  </td>                                  
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>



                  </div>
                </div>
              </div>
            </div>

            <!--<div class="row padding-top-3px">
              <div class="col-md-12" *ngIf="ReportDataModel">
                <div class="table-component" *ngFor="let obj of ReportDataModel">
                  {{obj.Name}}
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-20p table-fixed"
                           cols="auto,2*,*,*,*,*,*,*">
                      <thead class="">
                        <tr>
                          <th *ngFor="let col of obj.TableColumns |  keyvalue" class="padding-top-4px padding-bottom-4px th-sticky padding-left-10px">
                            {{col.value}}
                          </th>
                        </tr>
                      </thead>
                      <tbody class="table-body">
                        <tr *ngFor="let row of obj.TableRows">
                          <td class="td-padding-tb" *ngFor="let col of obj.TableColumns |  keyvalue">
                            {{row[col.value]}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>-->


            <!--<div class="row bk-color-sky" *ngIf="ReportDataModel">
    <div *ngFor="let obj of ReportDataModel">
      <div>
        <div class=" background-card">
          {{obj.Name}}
        </div>
        <table class="width-100pe overflow-auto1">
          <thead>
            <tr class="row">
              <th *ngFor="let col of obj.TableColumns |  keyvalue">
                {{col.value}}
              </th>
            </tr>
          </thead>
          <tbody class="table-body col-12">
            <tr class="row col-12" *ngFor="let row of obj.TableRows">
              <td *ngFor="let col of obj.TableColumns |  keyvalue">
                {{row[col.value]}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>


  </div>-->


          </div>


        </div>

      </div>
    </div>

  </div>


</div>

